import * as Highcharts from 'highcharts';
import * as jQuery from 'jquery';
import * as _ from 'underscore';

import { AfterContentChecked, Component, ElementRef, Input, OnDestroy, OnInit, ViewChild } from '@angular/core';

import { EmitterService } from '../../../../core/utility/services/emitter.service';
import { ColorPalette } from '../../../analytics-core/interfaces/partner.interface';
import { ColorConfig, DownloadConfig } from '../../../analytics-core/interfaces/widget.interface';
import { UtilityService } from '../../../../core/utility/services/utility.service';
import { ColorUtilityService } from '../../../analytics-core/services/color.utility.service';
import { EVENT_EMITTERS, R7_CHARTS_TOOLTIPS } from '../../../analytics/constants/analytics.constants';
import { AnalyticsDataModel } from '../../../analytics/models/analytics.datamodel';
import { AnalyticsService } from '../../../analytics/services/analytics.service';

@Component({
	selector: 'app-demographics-r7',
	styleUrls: ['./demographics-r7.component.css'],
	templateUrl: './demographics-r7.component.html'
})
export class DemographicsR7Component implements OnInit, AfterContentChecked, OnDestroy {
	@ViewChild('chartElement', { static: true }) graphElement: ElementRef;
	@Input() sectiontitle: string;
	@Input() key: string;
	@Input() downloadconfig: any;
	@Input() legend: any;
	@Input() colorsconfig: any;
	@Input() sectionclass: string;
	@Input() chartconfiguration: any;
	public showLoad = true;
	public hasData = false;
	public widgetDataSubscription;
	public reloadSubscription;
	public chartArrData = {};
	public activeIndex = 0;
	public primaryColor: any;
	public tertiaryColor: any;
	public secondary: any;
	public responseData: any;
	public downloadConfiguration: DownloadConfig;
	public seriesObj = [];
	public colorPalette: ColorPalette;
	public totalDemogImpClicks: object[] = [];
	public seriesObjR11 = [];
	public currentLegendItem = 'impressions';
	public nameMapping = {
		female: 'Female',
		male: 'Male',
		unknown: 'Unknown'
	};
	public downloadIcon: any = null;
	public toolTipDataConfg;
	public isR104: boolean = false;
	public isR103: boolean = false;

	constructor(
		protected analyticsService: AnalyticsService,
		protected analyticsDataModel: AnalyticsDataModel,
		protected colorUtilityService: ColorUtilityService
	) {
		this.reloadSubscription = EmitterService.get(EVENT_EMITTERS.RELOAD).subscribe((response: any) => {
			this.requestData();
		});
	}

	ngOnInit(): void {
		this.isR104 = this.analyticsDataModel.config.partner.directoryName === 'default-r104' ? true : false;
		this.isR103 =
			this.analyticsDataModel.config.directoryName.toLowerCase() === 'default-r103' ||
			this.analyticsDataModel.config.directoryName.toLowerCase() === 'entravision-r103'
				? true
				: false;
		this.legend = JSON.parse(decodeURI(this.legend));
		this.chartconfiguration = JSON.parse(decodeURI(this.chartconfiguration));
		this.primaryColor = this.colorUtilityService.getHEXByColorType(
			this.analyticsDataModel.partner.colorPalette,
			'primary',
			1
		);
		this.secondary = this.colorUtilityService.getHEXByColorType(
			this.analyticsDataModel.partner.colorPalette,
			'secondary',
			1
		);
		this.tertiaryColor = this.colorUtilityService.getHEXByColorType(
			this.analyticsDataModel.partner.colorPalette,
			'tertiary',
			1
		);
		this.downloadConfiguration = JSON.parse(decodeURI(this.downloadconfig));
		this.colorsconfig =
			typeof this.colorsconfig === 'string' ? JSON.parse(decodeURI(this.colorsconfig)) : this.colorsconfig;
		this.colorPalette = this.analyticsDataModel.partner.colorPalette;
		this.downloadIcon = this.analyticsDataModel.config.downloadIcon
			? this.analyticsDataModel.config.downloadIcon
			: this.downloadIcon;
		this.requestTooltipDataConfig();
		this.requestData();
	}

	ngAfterContentChecked(): void {
		jQuery('.social-demographic-gender-list-item').css(
			'backgroundColor',
			this.colorUtilityService.getRGBByOpacity('#ff742c', 0.5)
		);
		jQuery('.activeGender').css('backgroundColor', '#ff742c');
	}

	requestData(): void {
		this.showLoad = true;
		this.widgetDataSubscription = this.analyticsService
			.processCustomServiceRequest(this.key)
			.subscribe((response: any) => {
				this.showLoad = false;
				if (response.success && response.data.length > 0) {
					this.hasData = true;
					this.responseData = response.data;
					this.processResponseData(response.data);
				} else {
					this.hasData = false;
				}
			});
	}

	processResponseData(response: any): void {
		const demographicDataGroupedByGender: any = _.groupBy(response, 'gender');
		const ageGroupData = _.groupBy(response, 'age_group');
		this.chartArrData['all'] = {};
		// tslint:disable-next-line: forin
		for (const gender in demographicDataGroupedByGender) {
			this.chartArrData[gender] = {};
			demographicDataGroupedByGender[gender] = _.groupBy(demographicDataGroupedByGender[gender], 'age_group');

			this.legend.forEach((legend: any) => {
				const legendValue = legend.value;
				const legendValuesByCategories = [];
				this.chartArrData['all'][legendValue] = [];

				// tslint:disable-next-line:forin
				for (const ageGroup in demographicDataGroupedByGender[gender]) {
					const legendValueGroupByAge = demographicDataGroupedByGender[gender][ageGroup].reduce(
						(accumulator: any, currentValue: any): any => {
							return accumulator + Number(currentValue[legendValue]);
						},
						0
					);
					this.hasData = legendValueGroupByAge > 0 ? true : this.hasData;
					legendValuesByCategories.push(legendValueGroupByAge);
					this.chartArrData[gender][legendValue] = legendValuesByCategories;
				}

				const legendTotalArray = [];
				// tslint:disable-next-line: forin
				for (const age in ageGroupData) {
					const totalForLegend = ageGroupData[age].reduce((accumulator: any, currentValue: any): any => {
						return accumulator + Number(currentValue[legendValue]);
					}, 0);
					legendTotalArray.push(totalForLegend);
				}
				this.chartArrData['all'][legendValue] = legendTotalArray;
			});
		}
		this.buildSeriesObj(this.chartArrData);
		setTimeout(() => {
			if (this.hasData) {
				this.drawGraph();
			}
		});
	}

	requestTooltipDataConfig(): void {
		if (this.chartconfiguration?.graphConfig?.customTooltip === 'r7') {
			this.toolTipDataConfg = {
				...R7_CHARTS_TOOLTIPS,
				formatter(): string {
					return (
						// tslint:disable-next-line: prefer-template
						'<div style="color: #213038;font-size: 12px;text-align: center;">' +
						this.series.name.toLocaleString() +
						' ' +
						this.x.toLocaleString() +
						'</div><div style="color: #213038;font-size: 12px;text-align: center;font-weight: 600;">' +
						this.y.toLocaleString() +
						'</div>'
					);
				}
			};
		} else if (this.isR103) {
			this.toolTipDataConfg = {
				useHTML: true,
				formatter(): string {
					return (
						// tslint:disable-next-line: prefer-template
						'<div class="demographics-tooltip"><div class="demographics-tooltip-data">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;' +
						this.series.name.toLocaleString() +
						'&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</div><div class="demographics-tooltip-age">' +
						this.x.toLocaleString() +
						'</div></div><div class="demographics-tooltip-value">' +
						this.y.toLocaleString() +
						'</div>'
					);
				}
			};
		} else {
			this.toolTipDataConfg = {
				useHTML: true,
				formatter(): string {
					return (
						// tslint:disable-next-line: prefer-template
						'<div style="font-size: 12px;text-align: center;">' +
						this.series.name.toLocaleString() +
						' ' +
						this.x.toLocaleString() +
						'</div><div style="font-size: 12px;text-align: center;font-weight: 600;">' +
						this.y.toLocaleString() +
						'</div>'
					);
				}
			};
		}
	}

	buildSeriesObj(chartData: any): void {
		delete chartData['all'];
		this.seriesObj = [];
		let index = 0;
		// tslint:disable-next-line: forin
		for (const chartItem in chartData) {
			const seriesOb = {
				color: this.getColorFromColorConfig(index, 1),
				data: chartData[chartItem][this.currentLegendItem],
				name: this.nameMapping[chartItem]
			};
			this.seriesObj.push(seriesOb);
			index++;
		}
		const firstItem = this.seriesObj[0];
		this.seriesObj[0] = this.seriesObj[1];
		this.seriesObj[1] = firstItem;
		this.totalDemogImpClicks = [];
		this.seriesObjR11[0] = this.seriesObj[this.seriesObj.findIndex((x) => x.name === 'Female')];
		this.seriesObjR11[1] = this.seriesObj[this.seriesObj.findIndex((x) => x.name === 'Male')];
		this.seriesObjR11[2] = this.seriesObj[this.seriesObj.findIndex((x) => x.name === 'Unknown')];
		this.seriesObj.forEach((item) => {
			if (this.isR103) {
				if (item.name == 'Male') {
					item.name = 'Men';
				} else if (item.name == 'Female') {
					item.name = 'Women';
				} else if (item.name == 'Unknown') {
					item.name = 'Unknown';
				}
			}
			const totalImpClicks = {
				legendName: this.currentLegendItem.charAt(0).toUpperCase() + this.currentLegendItem.slice(1),
				name: item.name,
				value: 0
			};
			let calValue = 0;
			item.data.forEach((element) => {
				calValue += element;
			});
			totalImpClicks.value = calValue;
			this.totalDemogImpClicks.push(totalImpClicks);
		});
	}

	updateLegend(currentLegend: any): void {
		this.currentLegendItem = currentLegend;
		this.buildSeriesObj(this.chartArrData);
		this.drawGraph();
	}

	drawGraph(): void {
		const ageGroupData = Object.keys(_.groupBy(this.responseData, 'age_group'));
		Highcharts.chart('chart-element', {
			chart: {
				height: 400,
				type: 'column'
			},
			legend: {
				align: this.chartconfiguration?.graphConfig?.legendConfig?.align
					? this.chartconfiguration?.graphConfig?.legendConfig?.align
					: 'center',
				enabled: true,
				itemDistance: this.chartconfiguration?.graphConfig?.legendConfig?.itemWidth
					? this.chartconfiguration?.graphConfig?.legendConfig?.itemWidth
					: 80,
				itemMarginBottom: 30,
				symbolRadius: this.chartconfiguration?.graphConfig?.legendConfig?.symbolRadius
					? this.chartconfiguration.graphConfig.legendConfig.symbolRadius
					: 2,
				useHTML: true,
				verticalAlign: this.chartconfiguration?.graphConfig?.legendConfig?.verticalAlign
					? this.chartconfiguration.graphConfig.legendConfig.verticalAlign
					: 'top'
			},
			plotOptions: {
				column: {
					borderRadius: !UtilityService.isUndefinedOrNull(this.chartconfiguration?.graphConfig?.borderRadius)
						? this.chartconfiguration.graphConfig.borderRadius
						: 5,
					borderWidth: 0,
					groupPadding: this.isR104 ? 0.2 : 0.1,
					pointPadding: this.isR104 ? 0 : 0.08,
					pointWidth: this.chartconfiguration.graphConfig.pointWidth
				},
				series: {
					states: {
						inactive: {
							opacity: 1
						}
					}
				}
			},
			series: this.seriesObj,
			subtitle: {
				text: ''
			},
			title: {
				text: ''
			},
			tooltip: this.toolTipDataConfg,
			xAxis: {
				categories: ageGroupData,
				labels: {
					style: {
						fontSize: '12px',
						fontWeight: '600',
						lineHeight: 20
					},
					y: 25
				}
			},
			yAxis: {
				labels: {
					enabled: this.isR104 ? true : false
				},
				min: 0,
				title: {
					text: null
				},
				visible: this.isR104 || this.isR104 ? true : false
			}
		});
	}
	ngOnDestroy(): void {
		if (this.reloadSubscription) {
			this.reloadSubscription.unsubscribe();
		}
	}
	downloadCSV(): void {
		this.analyticsService.downloadCSV(
			this.downloadConfiguration.csvQueryKey ? this.downloadConfiguration.csvQueryKey : this.key,
			this.downloadConfiguration.fileName
		);
	}

	protected getColorFromColorConfig(index: number, opacity?: number): string {
		const colorConfig: ColorConfig = this.colorsconfig[index];
		const fillOpacity = opacity ? opacity : colorConfig.opacity;
		let rgb = '';
		if (colorConfig.isHex) {
			rgb = this.colorUtilityService.getRGBByOpacity(colorConfig.color, fillOpacity);
		} else {
			rgb = this.colorUtilityService.getRGBByColorType(this.colorPalette, colorConfig.color, fillOpacity);
		}
		return rgb;
	}
}
